const paymentCalendar = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Africa/Accra', year: 'numeric', month: '2-digit', day: '2-digit',
});
const paymentDisplay = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Africa/Accra', year: 'numeric', month: 'short', day: '2-digit',
});

function calendarDay(date: Date): number {
  const parts = paymentCalendar.formatToParts(date);
  const year = Number(parts.find(({ type }) => type === 'year')!.value);
  const month = Number(parts.find(({ type }) => type === 'month')!.value);
  const day = Number(parts.find(({ type }) => type === 'day')!.value);
  // Compare calendar dates, not elapsed hours or the customer's browser timezone.
  return Date.UTC(year, month - 1, day) / 86_400_000;
}

export function getPaymentCalendarDays(date: string | Date, now = Date.now()): number {
  return calendarDay(typeof date === 'string' ? new Date(date) : date) - calendarDay(new Date(now));
}

export function formatPaymentCalendarDate(date: string | Date): { day: string; monthYear: string } {
  const parts = paymentDisplay.formatToParts(typeof date === 'string' ? new Date(date) : date);
  return {
    day: parts.find(({ type }) => type === 'day')!.value,
    monthYear: `${parts.find(({ type }) => type === 'month')!.value}, ${parts.find(({ type }) => type === 'year')!.value}`,
  };
}
